import React, { ReactNode } from "react";
import styles from "../TherapistSteps.module.scss";
import cn from "classnames";

export const TherapistStepsLine = ({ children, className }: { children: ReactNode | string, className?: string }) => (
  <div className={cn(styles.line, className)}>
    {children}
  </div>
)
